/**
 * Mixin локализации
 */

export default {
    methods: {
        /**
         * Функция замены wildcards в тексте
         * @param text {String} - текст
         * @param wildcards {Object || null}, ассоциативный массив (объект) wildcards
         *  в формате ключ => значение
         * @returns {*}
         */
        replaceWildcards(text, wildcards) {
            if (!wildcards || typeof wildcards !== 'object') {
                return text;
            }

            for (let key in wildcards) {
                let value = wildcards[key];
                text = text.replaceAll(`:${key}`, value)
            }

            return text;
        }
    }
}
